import { render, staticRenderFns } from "./Callbackform.vue?vue&type=template&id=4200d199&"
import script from "./Callbackform.vue?vue&type=script&setup=true&lang=js&"
export * from "./Callbackform.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports